import {
  StaticDatePicker,
  StaticDatePickerProps,
} from "@mui/x-date-pickers/StaticDatePicker";

export type { StaticDatePickerProps };
export default StaticDatePicker;
